// extracted by mini-css-extract-plugin
module.exports = {"whiteCardNew":"_11RoM"};